import { createTheme, type PaletteMode } from "@mui/material";

export function buildTheme(mode: PaletteMode) {
  return createTheme({
    palette: {
      mode,
      ...(mode === "light"
        ? {
            primary: { main: "#0D2B67" },
            secondary: { main: "#FF6B00" },
            error: { main: "#CB2D1B" },
            background: { default: "#FDFDFE", paper: "#FFFFFF" },
          }
        : {
            primary: { main: "#4A7BFF" },
            secondary: { main: "#FF6B00" },
            error: { main: "#EF5350" },
            background: { default: "#121212", paper: "#1E1E1E" },
          }),
    },
    typography: {
      fontFamily: "'Inter', sans-serif",
      h1: { fontFamily: "'Playfair Display', serif" },
      h2: { fontFamily: "'Playfair Display', serif" },
      h3: { fontFamily: "'Playfair Display', serif" },
      h4: { fontFamily: "'Playfair Display', serif" },
      h5: { fontFamily: "'Playfair Display', serif" },
      h6: { fontFamily: "'Playfair Display', serif" },
    },
    shape: { borderRadius: 12 },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            borderRadius: 9999,
            fontWeight: 500,
          },
        },
        defaultProps: {
          disableElevation: true,
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            // px, not theme multiplier - keeps tables and dense UIs readable at corners
            borderRadius: "12px",
            border: "1px solid",
            borderColor: mode === "light" ? "#F0F0F0" : "#333",
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            borderRadius: 9999,
            "&.Mui-selected": {
              backgroundColor: "#FFE5D9",
              color: "#FF6B00",
              "&:hover": { backgroundColor: "#FFD6C4" },
            },
          },
        },
      },
    },
  });
}
